import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";

export const Wrapper = styled(Dialog)(() => ({
  flexDirection: "row"
}));